module.exports = __webpack_public_path__ + "static/img/solution.f421368e.png";